import { render, staticRenderFns } from "./ReportExpiredWarehouse.vue?vue&type=template&id=7dd57f10&scoped=true"
import script from "./ReportExpiredWarehouse.vue?vue&type=script&lang=ts"
export * from "./ReportExpiredWarehouse.vue?vue&type=script&lang=ts"
import style0 from "./ReportExpiredWarehouse.vue?vue&type=style&index=0&id=7dd57f10&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd57f10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/185/185admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7dd57f10')) {
      api.createRecord('7dd57f10', component.options)
    } else {
      api.reload('7dd57f10', component.options)
    }
    module.hot.accept("./ReportExpiredWarehouse.vue?vue&type=template&id=7dd57f10&scoped=true", function () {
      api.rerender('7dd57f10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/warehouse/ReportExpiredWarehouse.vue"
export default component.exports